module.exports = __webpack_public_path__ + "media/אף.7b311f0c.mp3";